<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer000" role="doc-foreword">
<p class="pl-center"><b>Acknowledgments</b></p>
<p class="pl-center">It takes many people to write a novel and I thank my wonderful and amazing family first and foremost—my husband and children who let me spend hours far away from them in another world. Thanks to Shannon McNear—you are always there for me! I couldn’t do it without you, friend. Writer friends Kathleen Y’Barbo Miller and Kellie Gilbert assisted me in figuring out my legal matters. I especially appreciate the technical expertise from my new friends in Juneau. I couldn’t have come close to getting things right without the time and detail they offered. Bill Glude of the Alaska Avalanche Information Center, Doug Wessen, president of the Mountain Rescue Association, and my friend who works for the<br/>US Forest Service in Juneau. If I got anything wrong, that’s all on me, but remember, I write fiction, and I created a whole new town.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?56f21930